import './top_spider_chart.js'

$(function(){
  var allLength=0;
  for( var i=0; i<$('.pageCon_rightList li').length; i++){
    allLength+=$('.pageCon_rightList li').height();
  }
  if( allLength > 520 ){
    $(".pageCon_rightList").mCustomScrollbar({
      alwaysShowScrollbar:2
    });
  }

  if($('body').hasClass('sp_body')){
    $(".pageCon_rightList").mCustomScrollbar("destroy");
  }
  //goTop
  $(window).on('scroll',function(){
    var e=$(window).scrollTop();
    e>200?$("#goTop").addClass("showTop"):$("#goTop").removeClass("showTop");
  })

  $('#goTop').on('click',function(){
    $("body,html").animate({scrollTop:"0px"},200);
  });

  $('.login_menu_box .menu_button').on('click',function(){
      setTimeout(function() {
          $('.login_menu_box .menu_content').toggle();},100)
  });

  $('.login_menu_box .menu_close_btn').on('click',function(){
      $(this).parent().hide();
  });

  $('.header_learning_btn').on('click',function(){
      $(this).parent().find('.header_learning_list').toggle();
      $(this).parent().toggleClass('on');
      $(this).find('i').toggleClass('fa-angle-down fa-angle-up');
  });

  $('.notice_box .title_notice').on('click',function(){
      $(this).parent().find('.notice_content').toggle();
      $(this).parent().toggleClass('on');
  });

  $(document).on('click', function (e) {
      if($('.login_menu_box .menu_content').css('display') == 'block'){
          var _con = $('.login_menu_box');   // 设置目标区域
          if(!_con.is(e.target) && _con.has(e.target).length === 0){ // Mark 1
              setTimeout(function() {
                  $('.login_menu_box .menu_content').hide()},50)
          }
      }
  });

  /*collect*/
  $('.compare_table .icon-circle-down').on('click',function(){
      $(this).toggleClass('icon-circle-up').parents('tr').next().next().toggle();
  });
  $('.sp_compare_table .icon-circle-down').on('click',function(){
      $(this).toggleClass('icon-circle-up').parents('tr').next().next().next().toggle();
  });

  /*if (navigator.userAgent.indexOf('Mac OS X') !== -1) {
  } else {
    $('body').addClass('pc');
  }*/

  /*$('.pageCon_cube').each(function(){
    if($(this).find('.detailed_cubeRight').find('li').length<=3){
      $(this).find('.detailed_cubeRight').addClass('detailed_cubeRight2');
    }
  });*/

  $('.sp_menu_btn,.sp_menu_modal').on('click',function(){
    $('.sp_searchBox').fadeOut();
    menuOn=true;
    if(menuOff){
      fixedOn();
      menuOff = false;
    }else{
      menuOff = true;
      fixedOff();
    }
  });
  //sp_serach
  $('.sp_body .sp_header .icon-search').on('click',function(){
    $('.sp_body #spMenuToggle').removeAttr('checked');
    menuOff = true;
    if(menuOn){
      fixedOn();
      menuOn=false;
    }else{
      menuOn=true;
      fixedOff();
    }
    $('.sp_searchBox').fadeToggle();
  });

  $('.sp_searchBox_dialog').on('click',function(){
      $('.sp_searchBox').fadeOut();
      menuOn=true;
      fixedOff();
  });

  $('body.sp_body').click(function(e) {
    var target = $(e.target);
    if(!target.is('.icon-search')) {
        if ( $('.sp_searchBox').is(':visible') ) {
            $('.sp_searchBox').hide();
            menuOn=true;
            fixedOff();
        }
    }
  });

  $(".sp_body .sp_searchBox .top_search").on("click", function(e){
    e.stopPropagation();
  });

  if($('.sp_ranking_sel li').length == 5){
    $('.sp_ranking_sel li:first-child').addClass('dis-block');
    $('.sp_body .pageCon_rankings .sp_ranking_sel>li:nth-child(2)').addClass('width-28');
  }

  $("#side_search input[type='text']").keydown(function (event) {
    if (event.keyCode == 13) {
      if ($.trim($(this).val()) == "") {
          return false;
      } else {
          $('#side_search input[name="utf8"]').remove();
      }
    }
  });

  $('#side_search #keywords_submit').on('click', function () {
    var keywords = $.trim($(this).siblings('input[type=text]').val());
    if (keywords == "") {
      return;
    } else {
        $('#side_search input[name="utf8"]').remove();
        $(this).parent('#side_search').submit()
    }
  });

  //热门关键词检索
  $('.top_search .side_hot_word_list li').on('click', function (){
      $('#side_search input[name="keywords"]').val($(this).text());
      $('#keywords_submit').click();
  });


  // spMenuToggle init
    if ($('#spMenuToggle').prop('checked')) {
        $('body').addClass('scroll_fixed');
    }

    //返回键sp版 menu 状态同步
    window.addEventListener( "pageshow",function(){
        if ($("input#spMenuToggle:checked").eq(0).length > 0) {
            fixedOn();
            menuOff = false;
        }
    })
    //#8835
    $('.ranking_tabs li').on('click',function(){
        $(this).addClass('cur').siblings().removeClass('cur');
        $('.ranking_table_wrapper').eq($(this).index()).removeClass('hide').siblings().addClass('hide');
    });
    //#10427
    $('.ui-common-tabs > ul > li').on('click',function(){
        $(this).addClass('cur').siblings().removeClass('cur');
        var _thisWrapper = $(this).parents('.ui-common-tabs').find('.tab_wrapper').eq($(this).index());
        ['hide', 'wrapper_hide'].forEach(function (value) {
            if(_thisWrapper.hasClass(value)){
                _thisWrapper.removeClass(value).siblings().addClass(value);
            }
        })
    });
    //#8835 top/sidebar spider
    topSpiderChartInit();

    //#10172
    adHideModal();

    // top Q&A
    $('.itf_qa ul li .tit').on('click', function(){
      if($(this).next('.des').hasClass('hide')) {
        $(this).next('.des').removeClass('hide');
        $(this).find('.fa').removeClass('fa-angle-down').addClass('fa-angle-up');
      } else {
        $(this).next('.des').addClass('hide');
        $(this).find('.fa').removeClass('fa-angle-up').addClass('fa-angle-down');
      }
    });

    //#11078
    compareLinkCheck();

    //#11118
    $('.favorite_close').on('click',function(){
        $('.favorite_guide_modal').fadeOut();
    });

    //#11910,#11911
    userRankingStatusFlag();
});

function navToggleHide(flag) {
    if(flag) {
        $('.sp_body .newheader .sp_index_nav').removeClass('hide');
        $('.sp_body .newheader + .sp_index_nav').addClass('hide');
    } else {
        $('.sp_body .newheader .sp_index_nav').addClass('hide');
        $('.sp_body .newheader + .sp_index_nav').removeClass('hide');
    }
}

function adHideModal() {
    $('.ad_hide').on('click',function(){
        $(this).next('.ad_hide_modal').show();
    });

    $('.ad_close').on('click',function(){
        $('.ad_hide_modal').fadeOut('');
    });
}

function drawCompareChart(containerId, compareList) {
    MST.SvgChart.setTimeFormatFunction( SW.ChartIntegration.formatTime );
    MST.SvgChart.setNumberFormatFunction( SW.ChartIntegration.formatNumber );
    MST.SvgChart.setTranslateFunction( SW.ChartIntegration.translateString );
    MST.sc_server = 'https://<%= Rails.env.production? ? "s3.sales-cue.jp" : "stg-s3.sales-cue.jp" %>/';

    var chart = document.getElementById(containerId);
    // remove all childnodes
    while(chart.hasChildNodes())
    {
        chart.removeChild(chart.firstChild);
    }

    var myChart = new MST.SvgChart(chart);
    var benchmarks = {
        ".N225": {id: ".N225", name: "日経平均", type: "index", index: 0},
        ".TOPX": {id: ".TOPX", name: "TOPIX",   type: "index", index: 1},
        ".DJI":  {id: ".DJI",  name: "ダウ",    type: "index", index: 2},
//        "11":    {id: "11", name: "金",  type: "futures", index: 3},
//        "33":    {id: "33", name: "原油", type: "futures", index: 4},
////        "81":    {id: "81", name: "ゴム", type: "futures", index: 5},
        // New code
        "2TCE01":    {id: "2TCE01", name: "金",  type: "futures", index: 3},
        "2TCE12":    {id: "2TCE12", name: "原油", type: "futures", index: 4},
        "JPY=X": {id: "JPY=X", name : "米ドル/円", type: "futures", index: 5},
    };
    benchList = benchmarks;

    for(var i = 0; i < compareList.length; i++){
        var type = "fund";

        if(i == 0) type = "default";

        benchmarks[compareList[i][0]] = {id: compareList[i][0],
            name: compareList[i][1], type: type, index: i + 6};
    }

    myChart.colorSelectList = {};
    myChart.setLanguage('jp');
    myChart.setBenchmarks(benchmarks);

    // MST.BENCHMARK_LIMIT = mobile ? 5 : 10;
    myChart.setParams(compareList[0][0], compareList[0][1], 'TYO', {
            controller: {timeFrame : '1Y', showController : true, showIndicator: false, showBenchmark: true,
                showUpdateBrowser: true, showChartRange: true, showType: true, showReset: false,
                ranges : ["3M", "6M", "1Y", "3Y", "5Y", "10Y", "ALL"]},
            scroll: {showScroll: true},
            technicalList : [['line']]
        }
    );

    for(var i = 1; i < compareList.length; i++){
        myChart.addBenchmark(compareList[i][0], i);
    }
    
    $('#chart_comment').removeClass('hide');

    document.addEventListener("click", function(e){
        e = e || window.event;
        var target = e.target || e.srcElement;
        if(e.button == 0 && target.className != "SvgChartIndicatorControllerView"){
            myChart.closeMenu();
        }
    });
}

var u = navigator.userAgent;
var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
var menuOff=true,
    menuOn=true,
    dialogOn=true,
    ananlysisDialogOff=true,
    fundCompareDailogOff=true,
    scrollTop=0,
    newTop=0;
    function fixedOn(){
        scrollTop=$(window).scrollTop();
        if(scrollTop!=0){
          newTop=scrollTop;
          $('body').css({'top':-newTop+'px'});
          $('.newheader').css({'top':scrollTop+'px','position':'absolute'});
        }else{
          if(!$('body').hasClass('scroll_fixed')){
            newTop=0;
            $('body').css({'top':0});
            $('.newheader').css({'top':0});
          }
        }
        navToggleHide(false);
        $('body').addClass('scroll_fixed');
    };
    function fixedOff(){
      if(menuOn&&menuOff&&dialogOn&&ananlysisDialogOff&&fundCompareDailogOff){
          $('body').removeClass('scroll_fixed');
          $('.newheader').css({'top':0,'position':'fixed'});
          $(window).scrollTop(newTop);
          setTimeout(function () {
              navToggleHide(true);
          }, 200)
      }
    };
/*dialog*/
var dialog={
    append:function(obj){
        var objHtml=$(obj).prop("outerHTML");
        $('.dialog_con').append(objHtml);
        $('.dialog_con').css({'marginLeft':-$(obj).width()/2,'marginTop':-$(obj).height()/2});
        $('.common_dialog').animate({right:0},'500');
        fixedOn();
        dialogOn=false;
        $('.dialog_bg').on('click',function(){
            dialog.remove();
        });
    },
    remove:function(){
        $('.common_dialog').animate({right:-100+'%'},'500');
        var dialogTimer=setTimeout(function(){
          $('.dialog_con').html('');
        },500)
        dialogOn=true;
        fixedOff();
    }
}

/*navigator*/
var sUserAgent = navigator.userAgent.toLowerCase();
var bIsIpad = sUserAgent.match(/ipad/i) == "ipad";
var bIsIphoneOs = sUserAgent.match(/iphone os/i) == "iphone os";
var bIsMidp = sUserAgent.match(/midp/i) == "midp";
var bIsUc7 = sUserAgent.match(/rv:1.2.3.4/i) == "rv:1.2.3.4";
var bIsUc = sUserAgent.match(/ucweb/i) == "ucweb";
var bIsAndroid = sUserAgent.match(/android/i) == "android";
var bIsCE = sUserAgent.match(/windows ce/i) == "windows ce";
var bIsWM = sUserAgent.match(/windows mobile/i) == "windows mobile";


// loading
let loading={
    html:'<div class="loading"><span class="icon-spinner3"> </span></div>',
    append:function(obj){
        obj.prepend(this.html);
    },
    remove:function(){
        $('.loading').remove();
    }
}

/****** pc modal fixed start ******/
var newTopPc= '', remodelFlag = true
function remodelOpen(){
    if (remodelFlag == true) {
        remodelFlag = false
        var scrollTop = $(window).scrollTop();
        newTopPc = scrollTop;
        $('body').css({'top':-newTopPc+'px'});
        $('body').addClass('scroll_fixed');
    }
}
function remodelClose(){
    remodelFlag = true
    if( $('body').hasClass('scroll_fixed')) {
        $('body').removeClass('scroll_fixed');
        $('body').css({'top':'auto'});
        $(window).scrollTop(newTopPc);
    }
}
/****** pc modal fixed end ******/

$(function () {
    var tableWidth=0;
    var parentWidth=0;
    if($(".pageCon_left").hasClass("pageCon_primerGlossary")){
        tableWidth=$(".pageCon_left.pageCon_primerGlossary table").width();
        parentWidth=$(".pageCon_primerGlossary_article").width();
        if(tableWidth>parentWidth){
            $(".pageCon_left.pageCon_primerGlossary table").width(parentWidth);
        }
    }

    //2020-10-29 anchor
    $('a[href^="#"]').click(function(){
        var speed = 400; 
        var href= $(this).attr("href");
        var target = $(href == "#" || href == "" ? 'html' : href);
        var position = target.offset().top - 120;
        $('body,html').animate({scrollTop:position}, speed, 'swing');
        return false;
    });
});

//function middleLoad(activeVal,middleHtml){
//  for(var i=0; i<MIDDLE_CLASS.length; i++){
//    if(activeVal == MIDDLE_CLASS[i][2]){
//      middleHtml+='<option value="'+ MIDDLE_CLASS[i][1] +'">'+ MIDDLE_CLASS[i][0] +'</option>'
//    }
//  }
//  $('#rankingMiddleClassList').html(middleHtml);
//}
//function smallLoad(activeVal,smallHtml,num){
//  for(var i=0; i<SMALL_CLASS.length; i++){
//    if(activeVal == SMALL_CLASS[i][num]){
//      smallHtml+='<option value="'+ SMALL_CLASS[i][1] +'">'+ SMALL_CLASS[i][0] +'</option>'
//    }
//  }
//  $('#rankingSmallClassList').html(smallHtml);
//}


function topGoogleAdsProbe(){
    var topAd = $('.top_breadcrumb + div[id^="div-gpt-ad"]');
    topAd.hide();

    var adsInterval = null,
        times = 0,
        interval = 500,
        duration = 60000;

    var maxTimes = ~~( duration / 500 );



    adsInterval = setInterval(function(){
        times ++;
        var _height = ~~( topAd.find('iframe').attr('height') );

        if(_height > 20){
            topAd.show();
            clearInterval(adsInterval);
        }else{
            topAd.hide();
        }

        if(times >= maxTimes){
            clearInterval(adsInterval);
        }
    }, interval)
}

$(function(){
    var scrollFun = (function(){
        var beforeTop = $(document).scrollTop();
        var afterTop = 0;
        var minTop = 40;
        var bodyClass = '';
        var pageConfig = {
            // 'pageCon_basicInfo': {minTop: 80, bodyClass: 'outer fund_body'},
            'pageCon_rankings': {minTop: 180, bodyClass: ''},
            'pageCon_screening': {minTop: 80, bodyClass: 'outer search_body'}
        };

        discernPage();

        function discernPage(){
            var  key = curKey();

            function curKey(){
                for(var k in pageConfig){
                    if($('.'+k).length > 0){
                        return k
                    }
                }
            }

            if(key in pageConfig){
                minTop = pageConfig[key]['minTop'];
                bodyClass =  pageConfig[key]['bodyClass'];
            }else{
                minTop = 40;
                bodyClass = '';
            }

            $('.sp_body').addClass(bodyClass);
        }


        return function(){
            $(document).scroll(function(){
                afterTop = $(this).scrollTop();
                if(afterTop > minTop){
                    if(afterTop > beforeTop){
                        $('.sp_body .newheader').addClass('down'); //header
                        $('.sp_index_nav').css({'top':'35px'});
                        $('.sp_body .sp_index_nav').addClass('down');
                        // $('.sp_body .fund_head_links').addClass('down'); //fund
                        $('.sp_body .sp_table_layer').addClass('down');  //ranking
                        //$('.sp_body .pageCon > .screenings_nav').addClass('down'); //search
                    }else{
                        $('.sp_body .newheader').removeClass('down');
                        $('.sp_index_nav').css({'top':'54px'});
                        $('.sp_body .sp_index_nav').removeClass('down');
                        // $('.sp_body .fund_head_links').removeClass('down');
                        $('.sp_body .sp_table_layer').removeClass('down');
                        //$('.sp_body .pageCon > .screenings_nav').removeClass('down');
                    }
                }else{
                    $('.sp_body .newheader').removeClass('down');
                    $('.sp_index_nav').css({'top':'54px'});
                    $('.sp_body .sp_index_nav').removeClass('down');
                    // $('.sp_body .fund_head_links').removeClass('down');
                    $('.sp_body .sp_table_layer').removeClass('down');
                    //$('.sp_body .pageCon > .screenings_nav').removeClass('down');
                }
                beforeTop = afterTop;

            })

        }
    })();

    scrollFun();
});


$(function(){
  displayViewFundPlate();
})


function saveLatestViewFunds(){
    var fundInfo = $('#fundInfo');
    if (fundInfo.length !== 0) {
        var fundId = fundInfo.attr('data-fund-id');
        var fund_data = {};
        var cookieFundData = $.cookie('fund_data');
        if($.isEmptyObject(cookieFundData)){
            fund_data['fund_id_arr'] = [];
        }else{
            fund_data = JSON.parse(cookieFundData);
            if(fund_data['fund_id_arr'].length > 5) fund_data['fund_id_arr'].splice(0, fund_data['fund_id_arr'].length - 5);
            var cur_index = fund_data['fund_id_arr'].indexOf(fundId);
            if(cur_index != -1){
                fund_data['fund_id_arr'].splice(cur_index,1);
            } else {
                if(fund_data['fund_id_arr'].length >= 5){
                    fund_data['fund_id_arr'].splice(0,1);
                }
            }
        }
        fund_data['fund_id_arr'].push(fundId);

        // Set the period of validity for 1 year.
        $.cookie('fund_data',JSON.stringify(fund_data),{path: '/', expires: 365});
        // Set cross-domain access for *.minkabu.jp
        $.cookie('fund_data',JSON.stringify(fund_data),{domain: 'minkabu.jp', path: '/', expires: 365});
    }
}

function displayViewFundPlate(){
    var fund_data = $.cookie('fund_data');
    if(fund_data){
        var fundIdArr = JSON.parse(fund_data)['fund_id_arr'];
        if(fundIdArr.length > 5) fundIdArr.splice(0, fundIdArr.length - 5);
        var fundArr = [];
        if(fundIdArr.length > 0){
            $.ajax({
                type: 'GET',
                url: '/fund/get_display_funds?fund_id_arr=' + fundIdArr,
                success: function(result){
                    fundArr = result.fund_data;
                    var arr = [];
                    fundArr.forEach(function (e) {
                        var fund_id = e['fund_id'].substring(0,8);
                        arr.push(fund_id)
                    })
                    var data = { 'fund_id_arr': arr.reverse() };
                    // Update valid fund_id.
                    // Set the period of validity for 1 year.
                    $.cookie('fund_data',JSON.stringify(data),{path: '/', expires: 365});
                    // Set cross-domain access for *.minkabu.jp
                    $.cookie('fund_data',JSON.stringify(data),{domain: 'minkabu.jp', path: '/', expires: 365});
                    showLatestViewFunds(fundArr, 'fund');

                    // #11673 ファンド比較
                    if($('#compare_popup').length > 0) showLatestCompareFunds(fundArr);
                    //銘柄一覧
                    //$('.stock_tabs span').on('click',function(){
                        //$(this).addClass('cur').siblings().removeClass('cur');
                        //$('.stock_table_box').eq($(this).index()).removeClass('hide').siblings().addClass('hide');
                    //});
                },
                error: function(e){
                    console.log(e.error);
                },
                complete: function(e) {
                    saveLatestViewFunds();
                }
            });
        }else{
            $('.latest_view_funds .no_data').removeClass('hide');
            if($('#compare_popup').length > 0) $('.latest_compare_funds .no_data').parent().removeClass('hide');
            saveLatestViewFunds();
        }
    }else{
        $('.latest_view_funds .no_data').removeClass('hide');
        if($('#compare_popup').length > 0) $('.latest_compare_funds .no_data').parent().removeClass('hide');
        saveLatestViewFunds();
    }

    var stock_data = $.cookie('recent_browsed_financial_items');
    if(stock_data) {
        var stockIdArr = JSON.parse(stock_data);
        var stockArr = [];
        if (stockIdArr.length > 0) {
            if (stockIdArr.length > 10) stockIdArr = stockIdArr.slice(0, 10);
            stockIdArr.forEach(function (idx) {
                stockArr.push(idx.stock_code)
            })
            var url = 'https://minkabu.jp/current_price.json?codes=' + stockArr.join(',')
            if($('body').hasClass('sp_body')) url = 'https://s.minkabu.jp/current_price.json?codes=' + stockArr.join(',')
            $.ajax({
                type: 'GET',
                cache: false,
                url: url,
                success: function (data) {
                    var result = data.items;
                    if (result.length > 0) {
                        var resultObj = {};
                        result.forEach(function (idx) {
                            resultObj[idx.financial_item.code] = idx
                        })
                        stockIdArr.forEach(function (idx, i) {
                            stockIdArr[i].stock_price = String(resultObj[idx.stock_code].d_price)
                            stockIdArr[i].stock_change = String(resultObj[idx.stock_code].d_change)
                        })
                        showLatestViewFunds(stockIdArr, 'stock')
                    }
                },
                error: function (e) {
                    console.log(e.error);
                }
            });
        } else {
            $('.latest_view_stocks .no_data').removeClass('hide');
        }
    } else {
        $('.latest_view_stocks .no_data').removeClass('hide');
    }

    function showLatestViewFunds(fundList, sort){
        var latestObj = {
            'fund': ['.latest_view_funds', 'ファンド名', '基準価額', '前日比'],
            'stock': ['.latest_view_stocks', '銘柄名', '現在値', '前日比']
        }
        var data = fundList;
        //$('.latest_view_table_title').remove();
        //$('.latest_view_table').remove();
        if(data.length > 0){
            //$('.popular_table_title').removeClass('cur');
            //$('.popular_table').addClass('hide');
            var fundDiv = document.createElement('div');
            //fundDiv.className = "stock_list";
            $(latestObj[sort][0]).append(fundDiv);

            //var subIndex = document.createElement('div');
            //subIndex.className = "md_sub_index nbline";
            //var h3 = document.createElement('h3');
            //$(h3).html('閲覧履歴');
            //subIndex.appendChild(h3);
            //fundDiv.appendChild(subIndex);

            //var mdCard = document.createElement('div');
            //mdCard.className = "md_card md_box";
            //fundDiv.appendChild(mdCard);

            //var spanTitle = document.createElement('span');
            //spanTitle.className = 'latest_view_table_title cur';
            //spanTitle.innerHTML = '閲覧履歴';
            //$('.popular_table_title').before(spanTitle);

            var mdBox = document.createElement('div');
            mdBox.className = "stock_table_box latest_view_table";
            fundDiv.appendChild(mdBox);

            if(sort === 'fund' && fundList.length >= 2) {
                var fundIdArr = JSON.parse(fund_data)['fund_id_arr'];
                if(fundIdArr.length > 5) fundIdArr.splice(0, fundIdArr.length - 5);
                var btnBox = document.createElement('div');
                btnBox.className = "md_box fsm";
                var btnLink = document.createElement('a');
                btnLink.className = "md_cssBtn size_m fsdbl fwb";
                btnLink.href = '/fund/compare?fund_ids=' + fundIdArr.join(',');
                btnLink.text = '最近見た銘柄を比較する';
                btnBox.appendChild(btnLink);
                fundDiv.appendChild(btnBox);
            }

            var table = document.createElement('table');
            table.className = "md_table fsm";
            mdBox.appendChild(table);

            var tbody = document.createElement('tbody');
            var firstTr = document.createElement('tr');
            $(firstTr).html('<th>'+latestObj[sort][1]+'</th>'+ '<th class="wsnw tac">'+latestObj[sort][2]+'</th>'+ '<th class="wsnw tac">'+latestObj[sort][3]+'</th>');
            tbody.appendChild(firstTr);
            for(var i = 0; i < data.length; i++){
                var fundItem = data[i];
                var tr = document.createElement('tr');
                for(var key in fundItem){
                    var renderFun = renderLatestViewFunds(key);
                    if(typeof renderFun == 'undefined') continue
                    var td = document.createElement('td');
                    if(key != "fund_id" && key != "stock_code"){
                        td.className = "wsnw tar";
                    }
                    var html = key == 'stock_code'? renderFun(fundItem[key], fundItem['stock_name']):renderFun(fundItem[key]);
                    $(td).html(html);
                    tr.appendChild(td);
                }
                tbody.appendChild(tr);
            }
            table.appendChild(tbody);
            //$('.popular_table').before(mdBox);

            //var trRow = $('.latest_view_table table tr:not(:first-child)');
            //for (let i = 0; i < trRow.length; i++){
                //$(trRow[i]).find('td:nth-child(2)').append($(trRow[i]).find('td span'));
                //$(trRow[i]).find('td span').addClass('d_block');
                //$(trRow[i]).find('td:nth-child(3)').remove();
            //}
        }
    }

    function renderLatestViewFunds(fundKey){
        var LatestViewConfig = {
            'fund_id': renderFundIdHtml ,
            'fund_price': renderFundPriceHtml,
            'fund_compare': renderFundCompareHtml,
            'stock_code': renderStockCodeHtml,
            'stock_price': renderStockPriceHtml,
            'stock_change': renderStockChangeHtml
        }
        if(fundKey in LatestViewConfig){
            return LatestViewConfig[fundKey];
        }
        function renderFundIdHtml(val){
            //fund_id, fund_name
            if(val.indexOf(',') > -1){
                var arr = val.split(',');
                var fund_id = arr[0];
                var fund_name = arr[1];
                var div = document.createElement("div");
                div.className = "ellipsis size_l";
                var a =  document.createElement("a");
                a.setAttribute('href','/fund/'+ fund_id);
                a.innerHTML = fund_name;
                div.appendChild(a);
                return div
            }
        }
        function renderStockCodeHtml(code, name){
            //stock_code, stock_name
            var div = document.createElement("div");
            div.className = "ellipsis size_l";
            var a =  document.createElement("a");
            a.setAttribute('href','https://minkabu.jp/stock/'+ code);
            a.innerHTML = name +' (' + code + ')' ;
            div.appendChild(a);
            return div
        }
        function renderFundPriceHtml(val){
            if(!isNaN(parseFloat(val))){
                val = parseFloat(val);
                val = val.toLocaleString();
            }else{
                val = "-";
            }
            return val + '円';
        }
        function renderStockPriceHtml(val){
            return val + '円';
        }
        function renderFundCompareHtml(val){
            //fund_compare, fund_status
            if(val.indexOf(',') > -1){
                var arr = val.split(',');
                var fund_compare = arr[0];
                var fund_status = arr[1];
                var span = document.createElement('span');
                var unit = "";
                if(!isNaN(parseFloat(fund_compare))){
                    fund_compare = parseFloat(fund_compare);
                }else{
                    fund_compare = "-";
                }
                if(fund_status == "up"){
                    unit = "+";
                }
                span.className = fund_status;
                span.innerHTML =  unit + fund_compare + '円';
                return span;
            }
        }
        function renderStockChangeHtml(val){
            //stock_change
            var fund_status = 'gray';
            var span = document.createElement('span');
            if(val.indexOf('+') != -1){
                fund_status = "up"
            }else if(val.indexOf('-') != -1){
                fund_status = "down"
            }
            span.className = fund_status;
            span.innerHTML = val + '円';
            return span;
        }
    }

    function showLatestCompareFunds(fundList) {
        var data = fundList;
        var fundIds = $('#compare_popup').attr('data-fund-ids').split('_')
        if(data.length > 0){
            var fundOuterDiv = document.createElement('div');
            var fundDiv = document.createElement('div');
            fundOuterDiv.className = $('body').hasClass('sp_body')? "md_card md_box":""
            fundDiv.className = $('body').hasClass('sp_body')? "compare-inner":"compare-inner company_scrollBar"
            fundOuterDiv.appendChild(fundDiv);
            $('.latest_compare_funds').append(fundOuterDiv);
            var tBox = document.createElement('table');
            tBox.className = "latest_compare_table md_table";
            fundDiv.appendChild(tBox);
            for(var i = 0; i < data.length; i++){
                var fund_name = data[i]['fund_id']
                var fund_id = ''
                if(fund_name.indexOf(',') > -1){
                    var arr = fund_name.split(',');
                    fund_id = arr[0];
                    fund_name = arr[1];
                }
                var tr = document.createElement('tr');
                tr.setAttribute("data-id-fund", fund_id);
                var tdTwo = document.createElement('td');
                var spanSub = document.createElement('span');
                spanSub.className = 'md_sub dis_block'
                $(spanSub).text(data[i]['fund_sub']);
                var spanName = document.createElement('span');
                spanName.className = 'fwb dis_block'
                $(spanName).text(fund_name);
                var tdOne = document.createElement('td');
                if(fundIds.indexOf(fund_id) != -1) {
                    tr.className = 'click-disabled'
                    $(tdOne).html('<i class="common_checkbox icon-checkmark"></i>')
                    tdOne.className = 'bg_light_blue'
                    tdTwo.className = 'bg_light_blue'
                } else {
                    $(tdOne).html('<i class="common_checkbox"></i>')
                }
                tdTwo.appendChild(spanSub);
                tdTwo.appendChild(spanName);
                tr.appendChild(tdOne);
                tr.appendChild(tdTwo);
                tBox.appendChild(tr);
            }
            $(".company_scrollBar").mCustomScrollbar({
                scrollInertia:150
            });
            comparePopHeight()
        }
    }
}


// svg_chart showCompareComment

function showCompareComment(i) {
    if (i > 0) {
        $('#chart_comment').removeClass('hide');
    } else {
        $('#chart_comment').addClass('hide');
    }
}

function isString(str){
    return (typeof str=='string')&&str.constructor==String;
}

function getByForm(url, params) {
    params["method"] = "get";
    requestByForm(url, params);
}

function postByForm(url, params) {
    params["method"] = "post";
    requestByForm(url, params);
}

function requestByForm(url, params) {
    var temp_form = document.createElement("form");
    temp_form.action = url;
    // temp_form.target = "_self";
    if(params["method"] == "POST" || params["method"] == "post"){
        temp_form.method = "post";
    }else{
        temp_form.method = "get";
    }
    temp_form.style.display = "none";
    var token = document.createElement('input');
    token.type = 'hidden';
    if(temp_form.method == "post"){
        token.name = "authenticity_token";
        token.value = $('meta[name=csrf-token]').attr('content');
        temp_form.appendChild(token);
    }
    for (var item in params) {
        if(item == "method") continue;
        var opt = document.createElement("textarea");
        opt.name = params[item].name;
        opt.value = params[item].value;
        temp_form.appendChild(opt);
    }
    document.body.appendChild(temp_form);
    temp_form.submit();
}

function toThousands(num, n) {
    if(num == null || num == "num"){
        return "-";
    }
    //n = n > 0 && n <= 20 ? n : 0;
    var plus = num.toString().indexOf("+") != -1 ? "+" : "";
    num = num.toString().indexOf("+") != -1 ? num.toString().split("+")[1] : num;
    var leftNum = num.toString().indexOf(".") != -1 ? num.toString().split(".")[0] : num;
    var rightStr = "";
    var tmpNum = num.toString();
    if (n >= 0) {
        // tmpNum = parseFloat(num).toFixed(n); //toThousands(1.255,2) error
        tmpNum = parseFloat(num).myRound(n);
    }
    var rightNum = tmpNum.toString().split(".")[1];

    // Correct the abnormal data
    // if(tmpNum.toString().split(".")[0] > parseInt(leftNum)){
    //     leftNum = (parseInt(leftNum) + 1).toString();
    // }
    if(tmpNum > 0 && tmpNum.toString().split(".")[0] > parseInt(leftNum)){
        leftNum = (parseInt(leftNum) + 1).toString();
    }else if(tmpNum < 0 && tmpNum.toString().split(".")[0] < parseInt(leftNum)){
        leftNum = (parseInt(leftNum) - 1).toString();
    }

    var leftStr = leftNum.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,');

    if (rightNum) {
        rightStr = "." + rightNum;
    }

    if(plus + leftStr + rightStr == "-0") return "0";

    return plus + leftStr + rightStr;
}

// 必须是float类型, n保留的位数
// 1.255.myRound(2)=>1.26
// 1.3456.myRound(3)=>1.346
// 0.myRound(3)=>error
Number.prototype.myRound = function (n) {
    n = n > 0 && n <= 20 ? n : 0;
    // var num = parseInt((this * Math.pow(10, n + 1)).toFixed(0));
    // var temp = new Decimal(Number(this)).mul(new Decimal(Math.pow(10, n + 1))).toNumber();
    // var num = parseInt(temp);
    //
    // var numStr = num.toString();
    // var lastNum = parseInt(numStr[numStr.length - 1]);
    // var addNum = lastNum > 4 ? 1 : 0;
    // // num = parseInt(this * Math.pow(10, n));
    // if(num < 10){
    //     if(num > 0) num = 0 + addNum;
    //     if(num < 0) num = 0 - addNum;
    // }
    // else{
    //     num = parseInt(num / 10)
    //     if(num > 0) num += addNum;
    //     if(num < 0) num -= addNum;
    // }
    //
    // return parseFloat(num / Math.pow(10, n));

    var tmp = new Decimal(Number(this)).mul(new Decimal(Math.pow(10, n))).toNumber();
    return new Decimal(tmp).round().div(new Decimal(Math.pow(10, n))).toNumber();
}

// val: input source val
// maxlength: 7-11 (正数: not[8(111,111), 4(1,111)] 负数 not[9, 5] 会少一位数)
// keyupType: keyup or clur
// floatType: int or float, 会四色五入
// negativeFlag: include "-"
// fullToHalfFlag: Full val to Half val
// decimal
function inputValToThousand(val, maxlength, autoNum, keyupType, floatType, negativeFlag, decimal) {
    if(autoNum == null) autoNum = 0;
    if(keyupType == null) keyupType = true;
    if(floatType == null) floatType = true;
    if(negativeFlag == null) negativeFlag = false;
    if(decimal == null) decimal = 2;

    autoNum += 1;
    var valNum = "";
    var valThousands = "";
    var reg = "0-9";
    if(floatType){
        reg += ".";
    }
    if(negativeFlag){
        reg += "-";
    }
    var arr = val.match(new RegExp("[" + reg + "]", 'g'));
    // alert(arr)
    // console.log(arr);
    // console.log(val);
    if(arr){
        // console.log("arr.length:" + arr.length);
        if(arr.length == 1){
            if(arr[0] == ".") {

            }else if(keyupType && arr[0] == "-"){
                valThousands = "-";
            }else{
                valNum = arr[0];
                valThousands = arr[0];
            }
        }else{
            var newArr = [];
            $.extend(newArr, arr);
            var lastVal = arr[arr.length - 1];
            if(lastVal == "-" || lastVal == "."){
                newArr.pop();
            }
            var tmpStr = newArr.join("");
            // console.log("tmpStr: " + tmpStr);
            valNum = parseFloat(tmpStr);
            // console.log("valNum: " + valNum);
            valThousands = toThousands(valNum, decimal);
            // console.log("==:" + val.indexOf(".") == -1);
            if(keyupType && newArr.indexOf(".") == -1 && lastVal == "."){
                valThousands += "."
            }else if(keyupType && tmpStr.substring(tmpStr.length-2, tmpStr.length) == '.0'){
                // input 10.0 => 10 error
                valThousands += ".0"
            }
        }
    }
    // console.log("valNum:" + valNum + "  valThousands: " + valThousands)
    var errorMaxNum = 10;
    if(autoNum <= errorMaxNum && valThousands.length > maxlength){
        var newVal = valThousands.substr(0, maxlength);
        // console.log(newVal.length + "  newVal1111:" + newVal);

        var arr = inputValToThousand(newVal, maxlength, autoNum, keyupType, floatType, negativeFlag, decimal)
        if(autoNum == errorMaxNum) console.log(maxlength + " - error autoNum:" + autoNum);
        if(autoNum < errorMaxNum && arr[1].length < maxlength){
            var maxlengthVal = valThousands[maxlength];
            // console.log("maxlengthVal:" + maxlengthVal);
            newVal = arr[1] + maxlengthVal;
            arr = inputValToThousand(newVal, maxlength, autoNum, keyupType, floatType, negativeFlag, decimal)
        }
        return arr
    }
    // console.log("valNum33333:" + valNum + "  valThousands: " + valThousands)
    return [valNum, valThousands];
}

function change_decimal_precision(value) {
    var result_value = value.toString();
    if (result_value === null || result_value === "") {
        return ""
    }
    else if (result_value === "-") {
        return "-"
    }
    else if(result_value.indexOf("%") !== -1){
        var result_value_0 = result_value.replace("%","");
        if(result_value_0.split(".")[1] === null || result_value_0.split(".")[1] === "" || result_value_0.split(".")[1] === undefined){
            return result_value
        }
        var _decimal = parseInt(result_value_0.split(".")[1].replace(/0*$/,""));
        if(isNaN(_decimal)){
            var result_value_1 = result_value_0.split(".")[0];
            return result_value_1 + "%";
        }else{
            return result_value;
        }
    }
    else if(result_value.indexOf("％") !== -1){
        var result_value_0 = result_value.replace("％","");

        if(result_value_0.split(".")[1] === null || result_value_0.split(".")[1] === ""){
            return result_value
        }
        _decimal = parseInt(result_value_0.split(".")[1].replace(/0*$/,""));
        if(isNaN(_decimal)){
            var result_value_1 = result_value_0.split(".")[0];
            return result_value_1 + "%";
        }else{
            return result_value;
        }
    }
    else if(result_value.indexOf("%") === -1 || result_value.indexOf("％") === -1){
        var unit = result_value.replace(",","").replace(/[-+]?[0-9]*\.?[0-9]+/,"");
        var num = result_value.replace(unit, "");
        if(num.split(".")[1] === null || num.split(".")[1] === "" || num.split(".")[1] === undefined){
            return result_value
        }
        _decimal = parseInt(num.split(".")[1].replace(/0*$/,""));
        if (isNaN(_decimal)) {
            result_value_0 = num.split(".")[0]
            return result_value_0 + unit;
        }else {
            var result_value_3 = num.replace(/[.]0*$/, "") + unit;
            return result_value_3
        }
    }
    else {
        return result_value;
    }
}

// JS获取url参数
function getQueryVariable(variable, url) {
    var query = url.substring(1);
    var vars = query.split("&");

    for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        if(pair[0] == variable){return pair[1];}
    }

    return(false);
}

// 銘柄比較-組入銘柄で比較 记住tab选择
function compareLinkCheck() {
    if(window.sessionStorage.getItem('compareLink') != null){
        var compareLink = JSON.parse(window.sessionStorage.getItem('compareLink'))
        var storageParams = getQueryVariable('fund_ids', compareLink.search);
        var params =  getQueryVariable('fund_ids', location.search);
        if(compareLink.url == location.href || (compareLink.url.indexOf(location.origin + location.pathname) != -1 && storageParams && params && storageParams == params)){
            if($('.user_blank_box').length > 0) $('.compare-btn li:last-child').trigger('click');//会员登录了
        }
    }
    window.sessionStorage.removeItem('compareLink');
}

// 銘柄比較-sp 版弹窗高度
function comparePopHeight() {
    if ($('body').hasClass('sp_body')) {
        var popH = $(window).height();
        var btnH = $('#compare_popup .ui-common-tabs > ul').outerHeight(true);
        var popBtnH = $('#compare_popup .detail_company_popup_btn').outerHeight(true);
        var divH = popH - btnH - popBtnH -  12 - 12;
        $('#compare_popup .compare-inner').css('max-height', divH);
    }
}

//#11910, #11911
function userRankingStatusFlag() {
    if($('#user_status').length > 0) {
        var userSts = $('#user_status').attr('date-user_status_flg');
        //console.log('userSts: '+userSts)

        if (userSts == "premium") {
            $('.fc_lock_yellow').hide();
        } else {
            $('.fc_lock_yellow').show();
        }
    }
}